import { connect } from 'react-redux';
import { compose } from 'redux';

import { createStructuredSelector } from 'reselect';
import {
  activeProjectCreditsSelector,
  activeProjectInstancesSelector
} from 'reducers/projects/activeProjectSelectors';
import {
  adminRoleSelector,
  projectsListSelector,
  validatedActiveProjectIdSelector
} from 'reducers/projects/selectors';
import ImmutableConverter from 'HOCs/ImmutableConverter';
import Sidebar from './component';

const mapStateToProps = createStructuredSelector({
  projectId: validatedActiveProjectIdSelector,
  projects: projectsListSelector,
  credits: activeProjectCreditsSelector,
  instances: activeProjectInstancesSelector,
  isAdmin: adminRoleSelector
});

const withConnect = connect(mapStateToProps);

export default compose(withConnect)(ImmutableConverter(Sidebar));
